export default "__VITE_ASSET__edd83d63__"